import { render } from "./data-list.vue?vue&type=template&id=66e0a32e&scoped=true"
import script from "./data-list.vue?vue&type=script&lang=js"
export * from "./data-list.vue?vue&type=script&lang=js"

import "./data-list.vue?vue&type=style&index=0&id=66e0a32e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e0a32e"]])

export default __exports__